﻿import { onEvent, getById } from "./_dom";

// Two functions below are for simple selects with the capability to add new options to the list
// <select id="select" data-allow-new-choice="input">
//	 <option>Option 1</option>
//	 <option>Option 2</option>
//	 <option>-- Add New Choice--</option>
// </select>
// <input id="input" class="hide" data-set-new-choice="select"/>

function getNewChoice(select, inputId) {
	const shouldShowInput = select.selectedIndex === select.options.length - 1;
	const input = getById(select.form, inputId);
	input.classList.toggle("hide", !shouldShowInput);
	if (shouldShowInput) {
		input.value = "";
		input.focus();
		input.select();
	}
}

function setNewChoice(input, selectId) {
	const context = input.form || input.closest("form");
	const select = getById(context, selectId);
	const newValue = input.value.trim();
	const newValueLC = newValue.toLowerCase();
	let i = 0;
	if (newValue !== "") {
		const options = select.options;
		const l = options.length;
		for (; i < l; i++) {
			if (options[i].value.toLowerCase() === newValueLC) {
				break;
			}
		}
		if (i == l) {
			select.insertBefore(new Option(newValue, newValue), options[--i]);
		}
	}
	if (select.selectedIndex != i) {
		select.selectedIndex = i;
		select.dispatchEvent(new Event("change", { bubbles: true }));
	}
	input.classList.add("hide");
}

function init(context) {
	onEvent(context, "[data-allow-new-choice]", "change", (_event, select) => {
		getNewChoice(select, select.dataset.allowNewChoice);
	});
	onEvent(context, "[data-set-new-choice]", "change", (_event, select) => {
		setNewChoice(select, select.dataset.setNewChoice);
	});
}

export { init };